<template>
  <div v-if="['drawer', 'modal'].includes(mode)">
    <slot />

    <b-modal v-model="modalStatus" width="90vw" :custom-class="modalClass">
      <options-drawer
        v-if="mode === 'drawer'"
        :options="options"
        :title="title"
      />

      <confirmation-modal
        v-else-if="mode === 'modal'"
        :description="description"
        :options="options"
        :title="title"
        @close="$emit('input', false)"
      />

      <div v-else-if="model === 'dropdown'">Dropdown</div>
    </b-modal>
  </div>

  <b-dropdown
    v-else
    class="lg:tw-rounded-lg"
    :mobile-modal="false"
    aria-role="list"
    :position="position"
  >
    <template #trigger>
      <slot />
    </template>

    <b-dropdown-item
      v-for="(option, index) in options"
      :key="index"
      aria-role="listitem"
      class="!tw-flex tw-items-center"
      @click="option.onClick"
    >
      <component
        :is="option.icon"
        v-if="option.icon"
        class="tw-font-bold tw-text-2xl tw-mr-1.5"
      />
      {{ option.title }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import ConfirmationModal from '@/components/shared/ConfirmationModal'
import OptionsDrawer from '@/components/shared/OptionsDrawer'

export default {
  components: {
    ConfirmationModal,
    OptionsDrawer,
  },
  props: {
    description: {
      default: '',
      required: false,
      type: String,
    },
    mode: {
      default: 'drawer',
      type: String,
      validator: (value) => ['drawer', 'modal', 'dropdown'].includes(value),
    },
    options: {
      required: true,
      type: Array,
    },
    title: {
      default: '',
      required: false,
      type: String,
    },
    value: {
      default: false,
      type: Boolean,
      required: true,
    },
    position: {
      default: 'is-bottom-left',
      type: String,
    },
  },
  computed: {
    modalClass() {
      if (this.mode === 'drawer') {
        return '!tw-justify-end'
      }

      return ''
    },
    modalStatus: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
